export default __webpack_public_path__ + "static/media/chevron-left-white.c641b9ce.svg";